var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import classNames from 'classnames';
import { DatePicker } from '@progress/kendo-react-dateinputs';
export function InlineEdit(_a) {
    var { as, children, className, variant, disableEdit = false, placeholder = '--', label, spellCheck = true, id, 'aria-labelledby': ariaLabelledby, dateValue, onDateChange } = _a, props = __rest(_a, ["as", "children", "className", "variant", "disableEdit", "placeholder", "label", "spellCheck", "id", 'aria-labelledby', "dateValue", "onDateChange"]);
    const Component = as || 'p';
    const variantClass = variant ? `qmb-inedit--${variant}` : 'qmb-inedit';
    const [isOpen, setIsOpen] = useState(false);
    const handleKeyDown = (e) => {
        var _a, _b;
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            (_a = e.currentTarget) === null || _a === void 0 ? void 0 : _a.blur();
        }
        else if (e.key === 'Escape') {
            e.preventDefault();
            (_b = e.currentTarget) === null || _b === void 0 ? void 0 : _b.blur();
        }
    };
    // Handle rendering a date picker when variant is 'date'
    if (variant === 'date') {
        const handleClick = () => {
            if (!disableEdit) {
                setIsOpen(true);
            }
        };
        const handleDateChange = (e) => {
            setIsOpen(false);
            if (onDateChange && e.value instanceof Date) {
                onDateChange(e.value);
            }
        };
        const formattedDate = dateValue instanceof Date && !Number.isNaN(dateValue.getTime())
            ? dateValue.toLocaleDateString()
            : children || placeholder;
        return (React.createElement("div", null,
            React.createElement(Component, Object.assign({ className: classNames({ [variantClass]: !disableEdit }, className), onClick: handleClick, "data-placeholder": placeholder, "data-label": label, id: id, "aria-labelledby": ariaLabelledby }, props), formattedDate),
            isOpen && !disableEdit && (React.createElement("div", { className: "qmb-inedit-date-picker" },
                React.createElement(DatePicker, { value: dateValue instanceof Date && !Number.isNaN(dateValue.getTime()) ? dateValue : null, onChange: handleDateChange, show: true, onBlur: () => setIsOpen(false) })))));
    }
    // Default inline edit component
    return (React.createElement(Component, Object.assign({ className: classNames({ [variantClass]: !disableEdit }, className), contentEditable: !disableEdit, suppressContentEditableWarning: !disableEdit, "data-placeholder": placeholder, "data-label": label, onKeyDown: !disableEdit ? handleKeyDown : undefined, spellCheck: !disableEdit ? spellCheck : false, id: id, "aria-labelledby": ariaLabelledby }, props), children));
}
